import Lottie from './lottie'
export default Lottie
